import React from 'react';
import Image from 'next/image';
import { image_base_url } from '@/constants/apiConstant';

import Breadcrumb from '../common/seo/BreadCrumbs';
import ApprovedTag from '../ui/components/ApprovedTag';
import Button from '../ui/components/Button';

const HeroSection = ({ collegeData, college_title, handleOpen, isAbroadCollege, breadcrumbItems }: any) => {
  return (
    <section className="relative h-full">
      <div className="relative">
        {/* Background Banner */}
        <div className="h-60 md:md:h-[21rem]">
          {collegeData?.banner?.[0]?.url && (
            <Image
              src={`${image_base_url}/${collegeData?.banner?.[0]?.name}`}
              alt={collegeData?.college_title ?? 'College Banner'}
              title={collegeData?.college_title ?? 'College Banner'}
              width={1520}
              height={288}
              className="h-60 w-full object-fill object-center md:h-[21rem]"
              quality={50}
              blurDataURL="blur"
              priority
              loading="eager"
              // unoptimized
            />
          )}
        </div>

        <div className="absolute inset-0 h-60 bg-black/75 md:h-[21rem] md:bg-black/50" />

        {/* Content Overlay */}
        <div className="absolute inset-0 flex flex-col px-4 pt-16 text-white lg:mx-auto lg:max-w-screen-xl lg:px-4 lg:pt-20">
          {/* Breadcrumb Section */}
          <div className="ml-2 truncate">
            <Breadcrumb items={breadcrumbItems} />
          </div>

          {/* Logo and Title Section */}
          <div className="my-2 flex flex-col gap-3 sm:flex-row sm:items-start md:my-4 md:gap-4">
            {/* College Logo */}
            <div className="flex items-start gap-3 sm:items-center">
              <div className="mt-2 size-12 rounded bg-white p-1 sm:size-16 md:size-24">
                {collegeData?.logo?.url && (
                  <Image
                    width={200}
                    height={200}
                    alt={collegeData?.college_title ?? 'College Logo'}
                    title={collegeData?.college_name ?? collegeData?.college_title ?? 'College Logo'}
                    src={`${image_base_url}/${collegeData?.logo?.name}`}
                    className="size-full object-fill object-center"
                    priority
                  />
                )}
              </div>

              {/* Title and Details */}
              <div className="flex w-full flex-col gap-1 sm:gap-2">
                <h1 className="text-sm font-semibold sm:text-lg md:font-bold lg:text-2xl">
                  {collegeData?.college_name} : {college_title}
                </h1>

                {/* Info Section */}
                <div className="flex flex-wrap items-center gap-2 truncate text-xs font-light sm:gap-4 sm:text-sm sm:font-normal">
                  {/* Location */}
                  <div className="flex gap-1">
                    {collegeData?.city?.publishedAt && collegeData?.city?.city_name},{' '}
                    {collegeData?.state?.publishedAt && collegeData?.state?.state_name}, {collegeData?.pin_code}
                  </div>

                  {/* Approval */}
                  {collegeData?.approved_by?.[0]?.organisation_name && (
                    <div className="flex items-center gap-1 sm:gap-2">
                      <div className="h-4 border-l border-white sm:h-6" />
                      <div className="flex items-center gap-1 sm:gap-2">
                        <span>Approved By:</span>
                        <ApprovedTag text={collegeData?.approved_by[0]?.organisation_name} />
                      </div>
                    </div>
                  )}
                  {/* College Type */}
                  {collegeData?.college_type?.college_type && (
                    <div className="flex items-center gap-1 sm:gap-2">
                      <div className="h-4 border-l border-white sm:h-6" />
                      {collegeData?.college_type?.college_type}
                    </div>
                  )}

                  {/* Foundation Year */}
                  {collegeData?.foundation_year && (
                    <div className="flex items-center gap-1 sm:gap-2">
                      <div className="h-4 border-l border-white sm:h-6" />
                      <span>Estd: {collegeData?.foundation_year}</span>
                    </div>
                  )}

                  {/* Genders */}
                  {collegeData?.genders?.length > 0 && (
                    <div className="flex items-center gap-1 sm:gap-2">
                      <div className="h-4 border-l border-white sm:h-6" />
                      <span>Genders: {collegeData?.genders?.map((item: any) => item?.gender).join(', ')}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Apply Now Button */}
          <div className="mt-5 hidden  items-center  justify-center gap-4 sm:justify-end md:flex">
            <Button
              text="Apply Now"
              outline
              onClick={() => handleOpen(collegeData?.id, collegeData?.abbreviation, isAbroadCollege)}
              outlineColor="border-white"
              textColor="text-white"
              paddingX="px-[10px]"
              paddingY="py-[10px]"
              width="w-28 md:w-36"
              align="text-center"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
